import { getCellValue as l } from "./atoms-v260.js";
function i(t) {
  var e;
  return ((e = l(t)) == null ? void 0 : e.getTime()) ?? -1;
}
export {
  i as getCellTime
};
